<template>
  <div class="supervisor-info-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="搬家详情" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="supervisor-detail ">
      <div class="supervisor-info">
        <div class="top">
          <div class="supervisor-logo">
            <img :src="imgUrl + supervisor.avatar">
          </div>
          <div class="supervisor-other">
            <div>{{supervisor.name}}</div>
            <div class="supervisor-auth" style="width: 1.85rem">
              <div class="platform-auth"><img src="../../assets/icon-shop-auth.png"/> <div>平台认证</div></div>
            </div>
          </div>
          <div class="supervisor-score">
            <div class="score">{{supervisor.score | score}}</div>
            评分
          </div>
        </div>
        <div class="bottom">
          <div>
            <div class="num">{{supervisor.serviceCount}}</div>
            <div class="label">已服务</div>
          </div>
          <div>
            <div class="num">{{supervisor.appointmentCount}}</div>
            <div class="label">已预约</div>
          </div>
          <div>
            <div class="num">{{supervisor.spares}}</div>
            <div class="label">可预约</div>
          </div>
        </div>
      </div>
    </div>
    <div class="supervisor-detail-tab">
      <div class="tab-item" @click="isLabel(0)" :class = "{'selected':isLabelNum == 0}">服务详情</div>
      <div class="tab-item" @click="isLabel(1)" :class = "{'selected':isLabelNum == 1}">下单须知</div>
      <div class="tab-item" @click="isLabel(2)" :class = "{'selected':isLabelNum == 2}">用户评价</div>
    </div>
    <div v-if="isLabelNum == 0">
      <div v-if="supervisor.serviceContent" class="service-content" v-html="supervisor.serviceContent"></div>
      <div v-if="!supervisor.serviceContent" class="black-page">
        <img src="../../assets/icon-no-img.png">
        <div class="tip">暂无该搬家工的服务详情!</div>
      </div>
    </div>
    <div class="intro general-box-shadow" v-if="isLabelNum == 1">
      <div v-if="supervisor.intro">{{supervisor.intro}}</div>
      <div v-else-if="!supervisor.intro" class="black-page">
        <img src="../../assets/icon-no-img.png">
        <div class="tip">该搬家工还没有下单须知哦!</div>
      </div>
    </div>
    <div class="evaluate-list" v-if="isLabelNum == 2">
      <div class="evaluate-item general-box-shadow" v-for="evaluate in customerEvaluateList">
        <img v-if="evaluate.customerAvatar" :src="evaluate.customerAvatar">
        <img v-if="!evaluate.customerAvatar" src="../../assets/icon/icon-defualt-avatar.png">
        <div class="evaluate-info">
          <div class="name">{{evaluate.customerName}}</div>
          <div class="date">{{evaluate.createTime | simpleDayFilter}}
            <img v-if="evaluate.update" class="icon-evaluate-edit-btn" @click="toCustomerEvaluateEdit(evaluate.id)" src="../../assets/icon-evaluate-reEdit.png"/>
          </div>
          <div class="content">{{evaluate.content}}</div>
        </div>
        <div class="evaluate-score">
          <div class="score">{{evaluate.score | score}}</div>
          评分
        </div>
      </div>
      <div v-if="customerEvaluateList.length == 0" class="black-page">
        <img src="../../assets/icon-no-img.png">
        <div class="tip">暂无该搬家工的相关评价信息!</div>
      </div>
    </div>
    <div class="appointment-btn" @click="reservationSupervisor(supervisor)">预约</div>
    <!--预约成功的提示框-->
    <div v-if="alertSuccess" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelCall()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">若已确定搬家服务 请拨打服务电话<br/>{{servicePhone}}<br/>进行预约沟通</div>
      <div class="agree-btn" @click="callUp()">确认拨打</div>
    </div>
    <div v-if="alertSuccess" class="pay-box"></div>

    <!--温馨提示 -->
    <div v-if="preAppointmentToast" class="toast appointment-reminder">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="closeAppointmentReminder">
      <div class="title">温馨提示</div>
      <div class="reminder-content">
        <div>搬家员完成服务后</div>
        <div>订金不予退还!</div>
        <div>为您造成的不便敬请谅解!</div>
      </div>
      <div class="agree-btn" @click = "prePayAppointment">确定</div>
    </div>
    <div v-if="preAppointmentToast" class="pay-box"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import {imgUrl,shareIcon} from '../../config'
  import SupervisorService from '../../service/SupervisorService'
  import EvaluateService from '../../service/customer/EvaluateService'
  import shareService from '../../service/share/ShareService'
  import AppointmentService from '../../service/customer/AppointmentService'
  import payUtil from '../../utils/Pay'
  import session from '../../utils/Session'

  export default {
    name: 'SupervisorDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        isLabelNum:0,
        supervisorId:'',
        supervisorType:'4',
        supervisor:{},
        customerEvaluateList:[],
        guaranteeList:[],
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        isWechatBrowser:this.$verfyBrowserType(),
        supervisorName:'',
        designPrice:'',
        servicePhone:'',
        alertSuccess:false,
        preAppointmentToast:false,
        prePayInfo:{},
      }
    },
    created(){
      this.supervisorName = this.$route.query.supervisorName;
      this.supervisorId = this.$route.query.supervisorId;
      if(this.global.isLabelNum){
        this.isLabelNum = this.global.isLabelNum;
        this.isLabel(this.isLabelNum);
        this.global.isLabelNum = 0;
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getSupervisorInfo(this.supervisorId);
    },
    methods: {
      isLabel(num){
        if(num == 1){
          this.isLabelNum=1;
        }else if(num == 2){
          this.isLabelNum=2;
          this.getEvaluateList();
        }else {
          this.isLabelNum=0;
        }
      },
      toCustomerEvaluateEdit(id){
        this.global.isLabelNum = this.isLabelNum;
        this.$router.push({name:'CustomerEvaluateEdit',query:{id}});
      },
      async reservationSupervisor(supervisor){
        if(supervisor.appointmentSwitch != '1'){
          Toast('该搬家员暂时不接受预约!');
        }else if(supervisor.appointmentSwitch == '1' && supervisor.spares == 0){
          Toast('该搬家员预约已满!');
        }else {
          this.servicePhone = supervisor.phone;
          if(supervisor.deposit && supervisor.deposit>0){
            this.preAppointmentToast = true;
          }else {
            var result = await AppointmentService.createAppointment({isDeposited:'0',type:this.supervisorType,customerId:session.getAccountToken().id,supervisorId:supervisor.id});
            if(result.code == '0'){
              this.alertSuccess = true;
            }else {
              Toast('预约失败');
            }
          }
        }
      },
      cancelCall(){
        this.alertSuccess = false;
      },
      callUp(){
        this.alertSuccess = false;
        window.location.href = "tel:"+this.servicePhone;
      },
      async getSupervisorInfo(id){
        var result = await SupervisorService.getSupervisorDetail(id);
        if(result.code == 0){
          this.supervisor = result.data;
          console.info('this.supervisor',this.supervisor)
        }else {
          Toast('获取搬家工详细信息失败');
        }
      },
      async getEvaluateList(){
        var result = await EvaluateService.evaluateList(this.supervisorId,this.supervisor.companyId,'',this.supervisorType);
        if(result.code == 0){
          this.customerEvaluateList = result.data;
          for (let evaluate of this.customerEvaluateList) {
            if(evaluate.customerUser != null){
              evaluate.customerName = evaluate.customerUser.nickname;
              evaluate.customerAvatar = evaluate.customerUser.avatarUrl;
            }
          }
        }else {
          Toast('获取搬家工评价信息失败');
        }
      },
      async initWechatShare(){
        let title = "推荐水木家居商城优选设计师";// 分享标题
        let desc = "我在水木家居商城找到一位好设计师“"+this.supervisorName+"”，推荐给想装修的朋友！"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      async prePayAppointment(){
        this.preAppointmentToast = false;
        let prepayResult = await AppointmentService.prePayAppointment({isDeposited:'1',type:this.supervisorType,customerId:session.getAccountToken().id,supervisorId:this.supervisor.id},this.supervisor.deposit);
        if(prepayResult.code == '0'){
          this.prePayInfo = payUtil.pay(prepayResult.data.prepayId,prepayResult.data.nonceStr);
          let requestPay = this.requestPay;
          if (typeof WeixinJSBridge == "undefined"){
            if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', requestPay, false);
            }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', requestPay);
              document.attachEvent('onWeixinJSBridgeReady', requestPay);
            }
          }else{
            this.requestPay();
          }
        } else {
          Toast(prepayResult.msg);
        }
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.alertSuccess = true;
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
                that.errorMsg = JSON.stringify(res)
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
      closeAppointmentReminder(){
        this.preAppointmentToast = false;
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/supervisor-detail.scss';
  @import '../../assets/style/common.scss';
  .supervisor-info-view .supervisor-detail{
    padding-bottom: 0rem;
  }
  .service-content{
    margin-bottom: 0.24rem;
    padding: 0.4rem 0.3rem 0.34rem;
    border-radius: 0.1rem;
    border: solid 1px #eee;
    line-height: 0.46rem;
    font-weight: bold;
    img{
      max-width: 100%;
      border-radius: 0.15rem;
      margin-bottom: 0.2rem;
    }
  }
</style>

